import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/service/config.service';
import { TokenService } from 'src/app/shared/services/customer-api/token.service';
import { RoutingService } from 'src/app/service/routing.service';
import { ApiBaseService } from '../api-base.service';

@Injectable({
  providedIn: 'root',
})
export class QuantApiService extends ApiBaseService {
  private quantApiUrl: string;

  constructor(
    http: HttpClient,
    config: ConfigService,
    routing: RoutingService,
    tokenService: TokenService,
  ) {
    super(http, config, routing, tokenService);
    this.quantApiUrl = this.config.appConfig.urlQuantApi;
  }

  protected getRequestUrl(endpoint: string, version?: string): string {
    if (version) {
      return `${this.quantApiUrl}/${version}/${endpoint}`;
    }
    return `${this.quantApiUrl}/${endpoint}`;
  }
}
